import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import * as commonDate from 'libs/commonDate';

import { IExTecnlLvlCdState, IUserItemState, IBirthItemState, IInquiryCndsState, ITecnlLvlCdState, ITEduTpCdState, ICertTpCdState, IpersonalInformationState, IschStatusListState, IcertStatusListState, IworkExpreListState, IdevelopCareerListState, IUsr0302MState } from '../../models/usr/usr0302m_model';

const initialState: IUsr0302MState = {
    // 조회조건
    inquiryCnds: {
        instCd: '',   // 기관코드
        empNo:  '',   // 사원번호(조회용)
        userId: '',   // 유저ID
        userNm: '',   // 직원명
        birdDt: '',   // 생년월일
        baseDt: commonDate.maskDate(commonDate.getToday(), 'YYYY-MM-DD')        // 기준년일자
    },
    
    // 직원 목록(조회조건 직원명 콤보)
    userList: [],

    // 생년월일 목록(조회조건 생년월일 콤보)
    birthList: [],

    // 기술등급 목록(신상정보 기술등급 콤보)
    tecnlLvlList: [],

    // 예상등급 목록(신상정보 예상등급 콤보)
    exTecnlLvlList: [],

    // 개발유형 목록(개발경력 개발유형 콤보)
    eduTpList: [],

    // 역할 목록(개발경력 역할 콤보)
    certTpList: [],

    // 신상정보
    userPersonalInformation: {
        userNm:      '',   // 직원명
        birdDt:      '',   // 생년월일
        grpNm:       '',   // 소속회사
        joinDt:      '',   // 입사일
        deptNm:      '',   // 부서
        postNm:      '',   // 직위
        tecnlLvlCd:  '',   // 기술등급
        exTecnlLvlCd:  '',   // 예상등급
        exprisCntnt: '',   // 전문기술
        prjExpreYm:  '',   // 프로젝트경력월수
        workExpreYm: ''    // 근무경력월수
    },

    // 학력 현황
    userSchStatusList: [],

    // 자격증 현황
    userCertStatusList: [],

    // 회사 근무 경력
    userWorkExpreStatusList: [],
    
    // 개발 경력
    userDevelopCareerStateList: [],

    pageSize: 10,   // 페이징사이즈
    current: 1,     // 현재페이지
}

export const usr0302m_Slice = createSlice({
    name: "usr0302m_Slice",
    initialState: initialState,
    reducers: {
        initState: (state) => {
            Object.assign(state, {...initialState
                                   , userList: state.userList
                                   , tecnlLvlList : state.tecnlLvlList
                                   , exTecnlLvlList : state.exTecnlLvlList}
                                );
        },
        setUserList: (state, action:PayloadAction<IUserItemState[]>) => {
            state.userList = action.payload;
        },
        setBirthList: (state, action:PayloadAction<IBirthItemState[]>) => {
            state.birthList = action.payload;
        },
        // setInquiryCnds: (state, action:PayloadAction<IInquiryCndsState>) => {
        //     state.inquiryCnds = action.payload;
        // },
        setInquiryCnds: (state, action: PayloadAction<Partial<IInquiryCndsState>>) => {
            state.inquiryCnds = {
                ...state.inquiryCnds,   // 기존 값 유지
                ...action.payload       // 넘어온 값만 덮어쓰기
            };
        },
        setTecnlLvlList: (state, action:PayloadAction<ITecnlLvlCdState[]>) => {
            state.tecnlLvlList = action.payload;
        },
        setExTecnlLvlList: (state, action:PayloadAction<IExTecnlLvlCdState[]>) => {
            state.exTecnlLvlList = action.payload;
        },
        setEduTpList: (state, action:PayloadAction<ITEduTpCdState[]>) => {
            state.eduTpList = action.payload;
        },
        setCertTpList: (state, action:PayloadAction<ICertTpCdState[]>) => {
            state.certTpList = action.payload;
        },
        setUserPersonalInformation: (state, action:PayloadAction<IpersonalInformationState>) => {
            state.userPersonalInformation = action.payload;
        },
        setUserSchStatusList: (state, action:PayloadAction<IschStatusListState[]>) => {
            state.userSchStatusList = action.payload;
        },
        setUserCertStatusList: (state, action:PayloadAction<IcertStatusListState[]>) => {
            state.userCertStatusList = action.payload;
        },
        setUserWorkExpreStatusList: (state, action:PayloadAction<IworkExpreListState[]>) => {
            state.userWorkExpreStatusList = action.payload;
        },
        setUserDevelopCareerStateList: (state, action:PayloadAction<IdevelopCareerListState[]>) => {
            state.userDevelopCareerStateList = action.payload;
        },
        setPageSize: (state, action:PayloadAction<number>) => {
            state.pageSize = action.payload;
        },
        setCurrent: (state, action:PayloadAction<number>) => {
            state.current = action.payload;
        },
    },
});

export default usr0302m_Slice.reducer;
export const Usr0302mAction  = usr0302m_Slice.actions;
export const Usr0302mReducer = usr0302m_Slice.reducer;